import './validationMessage.scss'

const ValidationMessage = ({ message, handleCloseEvent }: ValidationMessageProps) => {
  return (
    <div className="validation-message msds-shadow-medium mb-6 px-6 py-6 msds-text-body-0-bold msds-text-danger-red-1">
      <div>{message}</div>
      {handleCloseEvent && (
        <button type="button" className="validation-message__close" onClick={handleCloseEvent} aria-label="Close validation message">
          <svg viewBox="0 0 128 128" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path fill="unset" d="M63.646 54.433L99.079 19 109 28.921 73.567 64.354 108.29 99.08 98.371 109 63.645 74.276 29.63 108.29l-9.921-9.92 34.015-34.017L19 29.63l9.921-9.921z" />
          </svg>
        </button>
      )}
    </div>
  )
}

type ValidationMessageProps = {
  message: string
  handleCloseEvent?: () => void
}

export default ValidationMessage
